/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".checkbox-section[_ngcontent-%COMP%]{display:-webkit-box;display:flex;align-content:center;-webkit-box-align:center;align-items:center;height:60px}.checkbox-margin[_ngcontent-%COMP%]{margin:0 10px}"];
export { styles as styles };
